export default [
  {
    path: 'gansu/placeOrder',
    name: 'gansuPlaceOrder',
    meta: {
      title:'订单下单 / 甘肃移动号卡下单',
      isRefresh:true
    },
    component: () => import('@/views/gansu/placeOrder/placeOrder')
  }
]


// WEBPACK FOOTER //
// ./src/router/gansu.route.js